import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"

import { AVAILABLE_LOCALES, DEFAULT_LOCALE, NODE_ENV, INSTANCE } from "config"

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false
  }
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/locales/${INSTANCE}/{{lng}}/{{ns}}.json`,
    },
    detection: {
      lookupQuerystring: "lang",
      order: ["querystring", "localStorage"],
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: AVAILABLE_LOCALES,
    debug: NODE_ENV === "development",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    returnNull: false,
    returnObjects: true,
  })

export default i18n
